// removed by extract-text-webpack-plugin
module.exports = {"jobsToBeDone":"jobsToBeDone--3OO76","jobsToBeDoneCards":"jobsToBeDoneCards--1ftmV"};